// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3OsSc","header":"Messages_header__1FDm8"};